import React, { useEffect, useMemo, useState } from "react";

import { Img, Text } from "components";
import { FormInput } from "components/FormInput";
import Footer1 from "components/Footer1";
import InfoRibbon from "components/InfoRibbon";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { totalItemsInCarts } from "../../states/cart.mjs";
import { scrollToTop } from "../../helpers/scroll";
import { toast } from "react-toastify";
import { clearSearchKeyword } from "../../states/search.mjs";
import { cacheDb } from "../../service/cache";


const CartCheckoutAdressPagePage = () => {
  const [formData, setFormData] = useState({ fullname: "", email: "", mobile: "", region: "" });
  const [errors, setErrors] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    cacheDb.shipping.get("address")
      .then(v => {
        console.log(v,'___')
        if (v) {
          setFormData(v);
        }
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    if (totalItemsInCarts() < 1) {
      navigate("/productspage");
    }
  }, [navigate]);

  useEffect(() => {
    scrollToTop();
    return () => {
      clearSearchKeyword();
    };
  }, []);

  const validateFormData = useMemo(() => {
    return () => {
      let hasError = false;
      Object.keys(formData).forEach(x => {
        if (!formData[x] || formData[x] === "") {
          hasError = true;
          setErrors(p => ({ ...p, [x]: ["Field required"] }));
        }
        if (x === "email" && `${formData[x]}`.match(/^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/ig) === null) {
          hasError = true;
          setErrors(p => ({ ...p, [x]: ["Valid email required"] }));
        }
        if (x === "mobile" && `${formData[x]}`.match(/^(\+\d{1,3}[- ]?)?\d{10}$/ig) === null) {
          hasError = true;
          setErrors(p => ({ ...p, [x]: ["Valid mobile required"] }));
        }
        // if(x==="notes"){
        //   hasError=false;
        // }
      });
      if (hasError) {
        toast.error("Please fill required fields");
        scrollToTop(120);
      } else {
        cacheDb.shipping.put(formData, "address").catch(console.error);
        navigate("/cartcheckoutpaymentpage", {
          state: { ...formData }
        });
      }
    };
  }, [formData, navigate]);

  return (
    <>
      <div className="bg-gray-100 flex flex-col font-inter items-center justify-start mx-auto w-full">
        <InfoRibbon className="flex flex-row md:gap-10 items-center justify-between p-3 w-full" />
        <Header showSearch={false} />
        <Text
          className="my-[24px] text-2xl md:text-[22px] text-center text-gray-900_02 sm:text-xl tracking-[0.18px]"
          size="txtInterRegular24"
        >
          Billing Address
        </Text>
        <div
          className="bg-white-A700 flex flex-col items-center justify-start  p-[22px] rounded-lg w-[95%]">
          <div className="flex flex-col items-center justify-start my-0.5 w-full">
            <div className="flex-row flex gap-4 items-center w-full">
              <FormInput
                label="Fullname"
                value={formData?.fullname??''}
                onChange={(value) => {
                  setFormData(p => ({ ...p, fullname: value }));
                  setErrors(p => ({ ...p, fullname: [] }));
                }}
                errors={errors?.fullname}
                className="flex flex-col gap-[7px] items-start justify-start w-full" />
              <FormInput
                value={formData?.email??''}
                onChange={(value) => {
                  setFormData(p => ({ ...p, email: value }));
                  setErrors(p => ({ ...p, email: [] }));
                }}
                errors={errors?.email}
                className="flex flex-col gap-[7px] items-start justify-start w-full"
                label="Email"
              />
            </div>
            <div className="flex-row mt-4 flex gap-4 items-center w-full">
              <FormInput
                value={formData?.mobile??''}
                onChange={(value) => {
                  setFormData(p => ({ ...p, mobile: value }));
                  setErrors(p => ({ ...p, mobile: [] }));
                }}
                errors={errors?.mobile}
                className="flex flex-col gap-[7px] items-start justify-start w-full"
                label="Mobile"
                hinttext="Active mobile number"
              />
              <FormInput
                value={formData?.region??''}
                onChange={(value) => {
                  setFormData(p => ({ ...p, region: value }));
                  setErrors(p => ({ ...p, region: [] }));
                }}
                errors={errors?.region}
                className="flex flex-col gap-[7px] items-start justify-start w-full"
                label="City/Region"
                hinttext="Where do you live?"
              />
            </div>

            <FormInput
              value={formData?.notes??''}
              onChange={(value) => {
                setFormData(p => ({ ...p, notes: value }));
                setErrors(p => ({ ...p, notes: [] }));
              }}
              errors={errors?.notes}
              className="flex flex-col gap-[7px] mt-8 items-start justify-start w-full"
              label="Notes"
              lines={5}
              hinttext="Any extra instruction how we can deliver your items?"
            />
          </div>
        </div>
        <div onClick={() => {
          // navigate("/cartcheckoutpaymentpage");
          validateFormData();
        }}
             className=" cursor-pointer mt-14 flex w-[95%] items-center justify-start">
          <div
            className="flex bg-indigo-A700 rounded-[8px] flex-row cursor-pointer gap-3.5 items-center p-3 justify-center">
            <Img
              className="h-6 w-[23px]"
              src="images/img_payment_white_a700.svg"
              alt="payment"
            />
            <Text
              className="text-base text-white-A700 tracking-[0.25px]"
              size="txtInterRegular14"
            >
              Proceed to payment
            </Text>
          </div>
        </div>
        <Footer1 className="bg-blue_gray-900 flex items-center justify-center mt-24 md:px-5 w-full" />
      </div>
    </>
  );
};

export default CartCheckoutAdressPagePage;
